import React from "react";

const TemarioPosgradoMedicinaPrecisionGenomica = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Introducción a la medicina de precisión"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"El genoma humano"}</span></li>
                <li><span className="fw-light">{"El descubrimiento del ADN"}</span></li>
                <li><span className="fw-light">{"El año 2001"}</span></li>
                <li><span className="fw-light">{"El proyecto de genoma humano"}</span></li>
                <li><span className="fw-light">{"Herencia y tipos de herencia"}</span></li>
                <li><span className="fw-light">{"Enfoques Autonómicos. Situación actual"}</span></li>
                <li><span className="fw-light">{"La medicina de precisión"}</span></li>
                <li><span className="fw-light">{"Influencia de la genética y los factores ambientales en las enfermedades complejas"}</span></li>
                <li><span className="fw-light">{"La necesidad de precisión. El concepto de interacción"}</span></li>
                <li><span className="fw-light">{"El nuevo paradigma de las Especialidades de Precisión"}</span></li>
            </ul>
            <br /><br />
            <b>{"Las ómicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Biología molecular"}</span></li>
                <li><span className="fw-light">{"Genómica y Metagenómica"}</span></li>
                <li><span className="fw-light">{"Epigenómica y Transcriptómica"}</span></li>
                <li><span className="fw-light">{"Proteómica"}</span></li>
                <li><span className="fw-light">{"Metabolómica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Genoma humano: técnicas de laboratorio"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"El laboratorio de biología molecular"}</span></li>
                <li><span className="fw-light">{"Instrucciones básicas"}</span></li>
                <li><span className="fw-light">{"Material básico"}</span></li>
                <li><span className="fw-light">{"Extracción de ADN"}</span></li>
                <li><span className="fw-light">{"De saliva"}</span></li>
                <li><span className="fw-light">{"De sangre"}</span></li>
                <li><span className="fw-light">{"De otros tejidos"}</span></li>
                <li><span className="fw-light">{"Real-time PCR"}</span></li>
                <li><span className="fw-light">{"Introducción- historia del método"}</span></li>
                <li><span className="fw-light">{"Protocolos básicos usados"}</span></li>
                <li><span className="fw-light">{"Equipos más usados"}</span></li>
                <li><span className="fw-light">{"Secuenciación"}</span></li>
                <li><span className="fw-light">{"Introducción- historia del método"}</span></li>
                <li><span className="fw-light">{"Protocolos básicos usados"}</span></li>
                <li><span className="fw-light">{"Equipos más usados"}</span></li>
                <li><span className="fw-light">{"High-throughput"}</span></li>
                <li><span className="fw-light">{"Introducción"}</span></li>
                <li><span className="fw-light">{"Historia del método"}</span></li>
                <li><span className="fw-light">{"Ejemplos de estudios en humanos"}</span></li>
                <li><span className="fw-light">{"Expresión génica"}</span></li>
                <li><span className="fw-light">{"Genómica"}</span></li>
                <li><span className="fw-light">{"Transcriptómica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Categorización de variantes génicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"La Bioinformática en la búsqueda de la causa de la Enfermedad"}</span></li>
                <li><span className="fw-light">{"Análisis de Datos Genómicos"}</span></li>
                <li><span className="fw-light">{"Criterios de Patogenicidad"}</span></li>
                <li><span className="fw-light">{"Inteligencia artificial aplicada"}</span></li>
            </ul>
            <br /><br />
            <b>{"Interpretación de resultados"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"El ciclo del Diagnóstico Genético: del paciente al informe y del informe al paciente"}</span></li>
                <li><span className="fw-light">{"Interpretación de los Resultados del Laboratorio"}</span></li>
                <li><span className="fw-light">{"Elaboración de Informes para los Profesionales Clínicos"}</span></li>
                <li><span className="fw-light">{"Interpretación de Informes Genéticos"}</span></li>
                <li><span className="fw-light">{"Comunicación de Resultados a los pacientes"}</span></li>
            </ul>
            <br /><br />
            <b>{"Farmacogenómica y farmacogenética"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"La determinación de la respuesta al tratamiento"}</span></li>
                <li><span className="fw-light">{"Metabolizadores, Trasportadores y Receptores"}</span></li>
                <li><span className="fw-light">{"Desde las Variantes Génicas a los Efectos Adversos"}</span></li>
                <li><span className="fw-light">{"Análisis Farmacogenético"}</span></li>
                <li><span className="fw-light">{"Aplicando la Farmacogenética en la Clínica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Medicina personalizada de precisión hacia las nuevas terapias"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Nuevas estrategias en el desarrollo de Terapias Avanzadas"}</span></li>
                <li><span className="fw-light">{"Terapia Celular y Terapia Tisular"}</span></li>
                <li><span className="fw-light">{"Terapia Génica"}</span></li>
                <li><span className="fw-light">{"Las Nuevas Terapias en las Especialidades Clínicas"}</span></li>
                <li><span className="fw-light">{"Nanomedicina"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nutrigenética"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Control circadiano de la ingesta"}</span></li>
                <li><span className="fw-light">{". El eje cerebro-intestino. Bases moleculares y neurológicas de la conexión cerebro-intestino"}</span></li>
                <li><span className="fw-light">{"La cronobiología y la nutrición"}</span></li>
                <li><span className="fw-light">{". El reloj central. Los relojes periféricos. Las hormonas del ritmo circadiano. El control de la ingesta (leptina y grelina)"}</span></li>
                <li><span className="fw-light">{"Enfermedades crónicas no transmisibles"}</span></li>
                <li><span className="fw-light">{"El concepto del exposoma El concepto de la flexibilidad metabólica"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nutrigenómica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Diferencias y similitudes con la nutrigenética Componentes bioactivos de la dieta sobre la expresión génica El efecto de micro y macronutrientes sobre la expresión"}</span></li>
                <li><span className="fw-light">{". El ejemplo de la dieta Mediterránea"}</span></li>
                <li><span className="fw-light">{"Elementos claves de la nutrición de precisión"}</span></li>
                <li><span className="fw-light">{"Microbiota colónica"}</span></li>
                <li><span className="fw-light">{"Nutrigenómica aplicada"}</span></li>
                <li><span className="fw-light">{"Cronobiología"}</span></li>
                <li><span className="fw-light">{"Micronutrientes"}</span></li>
                <li><span className="fw-light">{"Vitaminas: liposolubles e hidrosolubles"}</span></li>
                <li><span className="fw-light">{"Minerales"}</span></li>
                <li><span className="fw-light">{"Metales pesados y tóxicos ambientales. Incidencia en la microbiota intestinal, la salud y las enfermedades crónicas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Genética de las enfermedades humanas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Genética de las enfermedades cardiometabólicas"}</span></li>
                <li><span className="fw-light">{"Genética de las cardiopatías"}</span></li>
                <li><span className="fw-light">{"Genética de la discapacidad intelectual"}</span></li>
                <li><span className="fw-light">{"Enfermedades genéticas en neonatología y pediatría"}</span></li>
                <li><span className="fw-light">{"Genética de las enfermedades neuromusculares"}</span></li>
                <li><span className="fw-light">{"Genética de las enfermedades neurosensoriales"}</span></li>
                <li><span className="fw-light">{"Genética de las enfermedades complejas"}</span></li>
                <li><span className="fw-light">{"Genética en psiquiatría"}</span></li>
            </ul>
            <br /><br />
            <b>{"Oncología y patología de precisión"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción a la Oncología y Patología de Precisión"}</span></li>
                <li><span className="fw-light">{"Cáncer de Mama"}</span></li>
                <li><span className="fw-light">{"Cáncer Ginecológico"}</span></li>
                <li><span className="fw-light">{"Cáncer de Pulmón, Cabeza y Cuello"}</span></li>
                <li><span className="fw-light">{"Cáncer y Sistema Digestivo"}</span></li>
                <li><span className="fw-light">{"Cáncer en Urología"}</span></li>
                <li><span className="fw-light">{"Sarcomas y Cáncer en Dermatología"}</span></li>
                <li><span className="fw-light">{"Neoplasias Hematológicas"}</span></li>
            </ul>
            <br /><br />
            <b>{"El diagnóstico genético en las enfermedades pediátricas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Trastornos del Neurodesarrollo y Déficit Intelectual"}</span></li>
                <li><span className="fw-light">{"Patología Prenatal, Defectos Congénitos"}</span></li>
                <li><span className="fw-light">{"Genética Clínica y Neonatologia"}</span></li>
                <li><span className="fw-light">{"Cromosomopatías"}</span></li>
                <li><span className="fw-light">{"Síndrome de Hipercrecimiento"}</span></li>
                <li><span className="fw-light">{"Enfermedades Endocrinológicas"}</span></li>
                <li><span className="fw-light">{"Enfermedades Metabólicas: EIM y Enfermedades de Depósito"}</span></li>
            </ul>
            <br /><br />
            <b>{"Aspectos éticos, sociales y legales de la genética en medicina"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Aspectos éticos y legales del diagnóstico genético"}</span></li>
                <li><span className="fw-light">{"Aspectos legales de la investigación biomédica"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioPosgradoMedicinaPrecisionGenomica;
